export const STAR_SPACE_ERROR = {
  message:
    'This space could not be added to starred spaces. Refresh and try again.',
};

export const UNSTAR_SPACE_ERROR = {
  message:
    'This space could not be removed from starred spaces. Refresh and try again.',
};
